/**––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––
 * ––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––
 * CSS
 */
import "../sass/common.scss";

/**––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––
 * ––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––
 * JS
 */

import objectFitImages from 'object-fit-images';

/**––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––
 * media-smooth_scrolling_2019
 * @link https://www.to-r.net/media/smooth_scrolling_2019/
 */
import smoothscroll from "smoothscroll-polyfill";

/**––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––
 * Slick
 */
import slick from "slick-carousel";

/**––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––
 * simplePARALLAX.js
 */
// import simpleParallax from 'simple-parallax-js';

/**––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––
 * ––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––
 */

/* smoothscroll */
smoothscroll.polyfill();

document.addEventListener("click", e => {
    const target = e.target;
    if (!target.classList.contains("js-smooth-scroll")) return;
    e.preventDefault();
    const targetId = target.hash;
    document.querySelector(targetId).scrollIntoView({
        behavior: "smooth",
        block: "start"
    });
});

/*––––– jQuery –––––*/
(function($){

    $(function(){
    });

})(jQuery);